import React from 'react';

interface IDefinitionListProps {
    children: React.ReactNode;
}

const DefinitionList = (props: IDefinitionListProps) => {
    return <div className="definition-list">{props.children}</div>;
};

export default DefinitionList;